const tagSlug = (slug: string, display: string) => {
  if (slug) {
    return slug;
  }

  return encodeURIComponent(display);
};

export default tagSlug;
